import { useEffect } from 'react';
import type { FitBoundsOptions, LatLngBounds } from 'leaflet';
import { useMap } from 'react-leaflet';
import { isUsableLatLngBounds, safeFitBounds } from '../../utils/leafletBounds';

/** Prefer this over MapContainer `bounds` — avoids fitBounds during attach with zero-size containers. */
export function FitMapBounds({
  bounds,
  options,
}: {
  bounds: LatLngBounds;
  options?: FitBoundsOptions;
}) {
  const map = useMap();
  useEffect(() => {
    if (!isUsableLatLngBounds(bounds)) return;
    safeFitBounds(map, bounds, options);
  }, [map, bounds, options]);
  return null;
}
